import AddEditCategoryFilters from '../../Community/Administer/AddEditCategoryFilters';
import AddEditPubDateFilter from './AddEditPubDateFilter';
import AddEditStandardFilters from './StandardFilters/AddEditStandardFilters';
import AddEditDrcAvailabilityFilter from './AddEditDrcAvailabilityFilter';
import OptionSelectionTypes from './OptionSelectionTypes';

const BrowseLaneType = {
	PubDate: {
		key: 'pubDate',
		headerLocalizationId: 'pubdate',
		addEditFiltersComponent: AddEditPubDateFilter,
	},
	Category: {
		key: 'category',
		headerLocalizationId: 'category',
		addEditFiltersComponent: AddEditCategoryFilters,
	},
	Publisher: {
		typeKey: 1611,
		type: 'titleAudienceSpecificVendorName',
		key: 'vendor',
		headerLocalizationId: 'publisher',
		addEditFiltersComponent: AddEditStandardFilters,
		optionSelectionType: OptionSelectionTypes.alpha,
	},
	Imprint: {
		typeKey: 1612,
		type: 'titleAudienceSpecificImprintName',
		key: 'imprint',
		headerLocalizationId: 'imprint',
		addEditFiltersComponent: AddEditStandardFilters,
		optionSelectionType: OptionSelectionTypes.alpha,
	},
	AgeRange: {
		typeKey: 700,
		type: 'titleAgeGradeRange',
		key: 'ageRange',
		headerLocalizationId: 'age_range',
		addEditFiltersComponent: AddEditStandardFilters,
		optionSelectionType: OptionSelectionTypes.select,
	},
	Format: {
		typeKey: 1613,
		type: 'titleAudienceSpecificFormat',
		key: 'format',
		headerLocalizationId: 'format',
		addEditFiltersComponent: AddEditStandardFilters,
		optionSelectionType: OptionSelectionTypes.alpha,
	},
	DrcAvailability: {
		key: 'drcAvailability',
		headerLocalizationId: 'drc_availability',
		addEditFiltersComponent: AddEditDrcAvailabilityFilter,
	},
	Lexile: {
		typeKey: 1509,
		type: 'titleLexile',
		key: 'lexile',
		headerLocalizationId: 'lexile',
		addEditFiltersComponent: AddEditStandardFilters,
		optionSelectionType: OptionSelectionTypes.select,
	},
	Dewey: {
		typeKey: 1506,
		type: 'titleDeweyClass',
		key: 'dewey',
		headerLocalizationId: 'dewey',
		addEditFiltersComponent: AddEditStandardFilters,
		optionSelectionType: OptionSelectionTypes.select,
	},
	Subrights: {
		typeKey: 800,
		type: 'titleSubright',
		key: 'subrights',
		headerLocalizationId: 'subrights',
		addEditFiltersComponent: AddEditStandardFilters,
		optionSelectionType: OptionSelectionTypes.select,
	},
	Edition: {
		typeKey: 1600,
		type: 'titleEditionType',
		key: 'edition',
		headerLocalizationId: 'edition',
		addEditFiltersComponent: AddEditStandardFilters,
		optionSelectionType: OptionSelectionTypes.select,
	},
	Pos: {
		key: 'pos',
		headerLocalizationId: 'pos_categories',
		doHide: true,
	},
};

export default BrowseLaneType;
